import React from 'react';
import styles from './FixedChar.module.scss';

interface FixedCharProps {
    type: string | 'group' | 'decimal' | 'literal' | 'currency';
    char: { type: string; value: string };
    charSrc?: string;
    size?: string | 'monospaced' | 'normal' | 'micro';
    merge?: string | 'left' | 'right';
}

const FixedChar: React.FC<FixedCharProps> = ({
    type,
    char,
    charSrc = '/animations/progressive-jackpot/img/fonts/jackpot',
    size = 'monospaced',
    merge = '',
}) => {
    const isolated = size === 'micro' ? '_isolated' : '';
    const resolveCharSrcSet = () => {
        return `
            ${charSrc}/1x/char_${char.type}${isolated}.png 1x,
            ${charSrc}/2x/char_${char.type}${isolated}@2x.png 2x,
            ${charSrc}/3x/char_${char.type}${isolated}@3x.png 3x
        `;
    };

    return (
        <div className={`${styles.wrapper} ` + `${styles?.[size] ?? ''} ` + `${styles?.[merge] ?? ''} ` + `${styles?.[type] ?? ''} `}>
            <div className={styles.keyhole}>
                {charSrc ? (
                    <img
                        width='38'
                        height='70'
                        className={styles.character}
                        src={`${charSrc}/01x/char_${char.type}${isolated}.png`}
                        srcSet={resolveCharSrcSet()}
                        alt={char.value}
                    />
                ) : (
                    <div className={styles.character}>{char.value}</div>
                )}
            </div>
        </div>
    );
};

export default FixedChar;
